const getHolidayIconName = (availableDays, date) => {
    if (!availableDays) {
        return '';
    }
    const HolyDay = availableDays.find(day => day.date === date && day.holiday);
    return HolyDay ? HolyDay.holiday.icon : '';
};

export { getHolidayIconName };
